import type { giftSendResponseInterface } from '@/types/apiType/giftType'
import type {
  luckyGiftBannerInterface,
  luckyGiftBackCoinsInterface,
  userEnterTheRoomBannerInterface
} from '~/types/viewsType/socketType'

// 礼物横幅类型
export enum GIFT_BANNER_TYPE {
  LUCKY = 'lucky',
  LARGE = 'large'
  // ENTER_THE_ROOM = 'enterTheRoom'
}
// 礼物横幅，包括：幸运礼物、大额礼物、进房横幅
interface giftBannerInterface
  extends Array<
    | (giftSendResponseInterface & {
        giftBannerViewType: GIFT_BANNER_TYPE.LARGE
      })
    | (luckyGiftBannerInterface & {
        giftBannerViewType: GIFT_BANNER_TYPE.LUCKY
      })
  > {}

// 礼物横幅
export const useGiftBannerStore = defineStore({
  id: 'giftBanner',
  state: () => ({
    giftBanners: [] as giftBannerInterface, // 礼物横幅，包括：幸运礼物、大额礼物
    enterRoomBanners: [] as userEnterTheRoomBannerInterface[], // 用户进房横幅
    luckyBackCoins: null as null | luckyGiftBackCoinsInterface, // 最新的幸运礼物返币信息
    rideEffects: [] as userEnterTheRoomBannerInterface[] // 进房座驾特效动画，播放特效的轮播
  }),
  actions: {
    /**
     * 添加幸运礼物横幅
     */
    addLuckyGiftBanner(data: luckyGiftBannerInterface) {
      const roomStore = useRoomStore()
      // 进房情况下才添加
      if (roomStore.roomId) {
        this.giftBanners.push({
          ...data,
          giftBannerViewType: GIFT_BANNER_TYPE.LUCKY
        })
      }
    },
    /**
     * 添加大额礼物横幅
     */
    addLargeGiftBanner(data: giftSendResponseInterface) {
      const roomStore = useRoomStore()
      // 进房情况下才添加
      if (roomStore.roomId) {
        this.giftBanners.push({
          ...data,
          giftBannerViewType: GIFT_BANNER_TYPE.LARGE
        })
      }
    },
    /**
     * 移除横幅子集
     * @param {shift} type '移除类型：shift：第一项, all：全部'
     * */
    removeGiftBanner(params: { type: 'shift' | 'all' }) {
      if (params.type === 'shift') {
        this.giftBanners.shift()
      } else if (params.type === 'all') {
        this.giftBanners = []
      }
    },
    /**
     * 设置返币信息
     * @param data 幸运礼物返币信息
     */
    setLuckyBackCoins(data: typeof this.luckyBackCoins) {
      this.luckyBackCoins = data
    },
    /**
     * 添加用户进房横幅
     */
    addUserEnterTheRoomBanner(data: userEnterTheRoomBannerInterface) {
      const roomStore = useRoomStore()
      // 进房情况下才添加
      if (roomStore.roomId) {
        this.enterRoomBanners.push(data)
      }
    },
    /**
     * 移除横幅子集
     * @param {shift} type '移除类型：shift：第一项, all：全部'
     * */
    removeEnterTheRoomBanner(params: { type: 'shift' | 'all' }) {
      if (params.type === 'shift') {
        this.enterRoomBanners.shift()
      } else if (params.type === 'all') {
        this.enterRoomBanners = []
      }
    },
    /**
     * 添加礼物特效
     */
    addEnterRideEffects(data: userEnterTheRoomBannerInterface) {
      this.rideEffects.push(data)
    },
    /**
     * 移除进房座驾特效
     * @param {shift} type '移除类型：shift：第一项'
     * */
    removeEnterRideEffects(params: { type: 'shift' | 'all' }) {
      if (params.type === 'shift') {
        this.rideEffects.shift()
      }
    }
  }
  // persist: {
  //   key: 'giftBannerStore',
  //   paths: []
  // }
})
